/**
 * nimbus-add-notification.js
 * ──────────────────────────
 * cart-notification custom element — product-form.js zoekt dit als eerste.
 * Toont een centraal popup na add-to-cart. Geen redirect naar cart pagina.
 */

class CartNotification extends HTMLElement {
  constructor() {
    super();
    this._timer  = null;
    this._dur    = 4000; /* ms voor auto-dismiss */

    this.card     = this.querySelector('.ncn__card');
    this.backdrop = this.querySelector('.ncn__backdrop');
    this.imgWrap  = this.querySelector('.ncn__img-wrap');
    this.img      = this.querySelector('.ncn__product-img');
    this.titleEl  = this.querySelector('.ncn__title');
    this.variant  = this.querySelector('.ncn__variant');
    this.price    = this.querySelector('.ncn__price');
    this.fill     = this.querySelector('.ncn__progress-fill');

    this.querySelector('.ncn__close').addEventListener('click', this.close.bind(this));
    this.querySelector('.ncn__continue').addEventListener('click', this.close.bind(this));
    this.backdrop.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', function(e) { if (e.code === 'Escape') this.close(); }.bind(this));
  }

  /* ── Dawn product-form.js verwacht deze methoden ── */

  getSectionsToRender() {
    return [
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  setActiveElement(el) {
    this.activeElement = el;
  }

  /* Aangeroepen door product-form.js na succesvolle add-to-cart */
  renderContents(parsedState) {
    /* Update cart icon bubble */
    var sections = parsedState.sections || {};
    var bubbleSection = sections['cart-icon-bubble'];
    if (bubbleSection) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var parsed = new DOMParser().parseFromString(bubbleSection, 'text/html');
        var fresh  = parsed.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }

    /* Vul notification met product info */
    this._populate(parsedState);
    this.open();
  }

  _populate(item) {
    /* Product image */
    if (item.featured_image && item.featured_image.url) {
      this.img.src = item.featured_image.url.replace('_{width}x', '_200x');
      this.img.alt = item.featured_image.alt || item.title || '';
      this.imgWrap.href = item.url || '#';
      this.imgWrap.style.display = '';
    } else if (item.image) {
      this.img.src = item.image;
      this.img.alt = item.title || '';
      this.imgWrap.href = item.url || '#';
      this.imgWrap.style.display = '';
    } else {
      this.imgWrap.style.display = 'none';
    }

    /* Titel */
    this.titleEl.textContent = item.product_title || item.title || '';

    /* Variant + quantity */
    var variantTitle = item.variant_title || '';
    var qty = item._addedQty || item.quantity || 1;
    var variantParts = [];
    if (variantTitle && variantTitle.toLowerCase() !== 'default title') variantParts.push(variantTitle);
    if (qty > 1) variantParts.push('Qty: ' + qty);

    if (variantParts.length) {
      this.variant.textContent = variantParts.join(' · ');
      this.variant.style.display = '';
    } else {
      this.variant.style.display = 'none';
    }

    /* Prijs — gebruik line price zodat quantity meegeteld wordt */
    var price = item.final_line_price || item.line_price || item.final_price || item.price || 0;
    this.price.textContent = this._formatMoney(price);
  }

  _formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, '{{amount_with_comma_separator}} EUR');
    }
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  open() {
    clearTimeout(this._timer);
    document.body.classList.add('overflow-hidden');
    this.classList.add('is-open');
    this.card.focus();

    /* Auto-dismiss timer met visuele progress bar */
    var fill = this.fill;
    fill.classList.remove('is-counting');
    fill.style.setProperty('--ncn-duration', (this._dur / 1000) + 's');
    /* Force reflow zodat de reset registered is */
    void fill.offsetWidth;
    fill.classList.add('is-counting');

    var self = this;
    this._timer = setTimeout(function() { self.close(); }, this._dur);
  }

  close() {
    clearTimeout(this._timer);
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    this.fill.classList.remove('is-counting');
    if (this.activeElement) {
      setTimeout(function() { if (this.activeElement) this.activeElement.focus(); }.bind(this), 50);
    }
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}


/* ─────────────────────────────────────────────────────────
   AJAX interceptor voor .nmpd-form (Nimbus product page)
   Vangt de gewone POST op → AJAX → toont notification
   ───────────────────────────────────────────────────────── */
(function() {
  function interceptNmpdForms() {
    document.querySelectorAll('.nmpd-form').forEach(function(form) {
      if (form.dataset.nimbusIntercepted) return;
      form.dataset.nimbusIntercepted = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        var btnText = btn ? btn.querySelector('span, .btn-add-text') || btn : null;
        var originalText = btnText ? btnText.textContent : '';

        /* Laadstatus op knop */
        if (btn) {
          btn.setAttribute('aria-disabled', 'true');
          if (btnText) btnText.textContent = '...';
        }

        var formData = new FormData(form);

        /* Vraag Shopify ook de cart-icon-bubble sectie terug te sturen */
        var notification = document.querySelector('cart-notification');
        if (notification && notification.getSectionsToRender) {
          var sectionIds = notification.getSectionsToRender().map(function(s) { return s.id; }).join(',');
          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(function(r) { return r.json(); })
        .then(function(response) {
          if (response.status) {
            /* Shopify fout (bijv. uitverkocht) */
            console.warn('Cart add error:', response.description);
            if (btn) {
              btn.setAttribute('aria-disabled', 'false');
              if (btnText) btnText.textContent = originalText;
            }
            return;
          }

          /* Herstel knop */
          if (btn) {
            btn.setAttribute('aria-disabled', 'false');
            if (btnText) btnText.textContent = originalText;
          }

          /* Toon notification */
          if (notification && notification.renderContents) {
            notification.renderContents(response);
          }

          /* Update cart teller via /cart.js → [data-cart-count] */
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              /* Nimbus header teller direct updaten */
              var badge = document.querySelector('[data-cart-count]');
              if (badge) {
                badge.textContent = cart.item_count;
                badge.classList.toggle('is-empty', cart.item_count === 0);
              }
              /* aria-label op de cart link updaten */
              var cartLink = document.querySelector('.nimbus-header__cart');
              if (cartLink) cartLink.setAttribute('aria-label', 'Cart (' + cart.item_count + ')');
              /* Cart drawer header teller updaten */
              var drawerCount = document.querySelector('.nimbus-cart__head-count');
              if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
              /* Menu drawer "Cart (X)" link updaten */
              document.querySelectorAll('.nimbus-drawer__meta-link[href*="cart"]').forEach(function(el) {
                el.textContent = 'Cart (' + cart.item_count + ')';
              });
              /* Cart drawer header teller updaten */
              var drawerCount = document.querySelector('.nimbus-cart__head-count');
              if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
              /* Menu drawer "Cart (X)" link updaten */
              document.querySelectorAll('.nimbus-drawer__meta-link[href*="cart"]').forEach(function(el) {
                el.textContent = 'Cart (' + cart.item_count + ')';
              });

              /* PubSub event voor andere listeners (nimbus-header.js refreshCount) */
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: cart });
              }
              /* Fallback: dispatch cart:refresh custom event */
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            });
        })
        .catch(function(err) {
          console.error('Add to cart failed:', err);
          if (btn) {
            btn.setAttribute('aria-disabled', 'false');
            if (btnText) btnText.textContent = originalText;
          }
        });
      });
    });
  }

  /* Init op DOM ready + opnieuw na dynamische content */
  document.addEventListener('DOMContentLoaded', interceptNmpdForms);
  /* Fallback voor late-loaded forms */
  document.addEventListener('page:load', interceptNmpdForms);
})();

/* ── Cart link in menu drawer → menu sluiten, cart drawer openen ── */
document.addEventListener('click', function(e) {
  var link = e.target.closest('.nimbus-drawer__meta a[href*="cart"]');
  if (!link) return;
  e.preventDefault();
  e.stopPropagation();

  /* Sluit menu drawer via data-drawer-close klik */
  var closeBtn = document.querySelector('.nimbus-drawer.is-open [data-drawer-close]');
  if (closeBtn) closeBtn.click();

  /* Open cart drawer na animatie */
  setTimeout(function() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }, 350);
});
